export default "__VITE_ASSET__a9f355dc__"